import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthProvider';

/**
 * Guarda de rutas: las rutas hijas solo se renderizan con sesión válida.
 */
export function ProtectedRoute() {
    const { user, checkSession } = useAuth();
    const location = useLocation();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;
        void checkSession().then(() => {
            if (!cancelled) setReady(true);
        });
        return () => {
            cancelled = true;
        };
    }, [checkSession]);

    if (!ready) {
        return (
            <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', minHeight: '100dvh' }}>
                <div className="spinner" aria-label="Cargando sesión" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    return <Outlet />;
}
